import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, effect, ElementRef, input, linkedSignal, output, viewChild } from '@angular/core';
import { SdDatepicker, SdRadioGroup, SdSelect } from '@solid-design-system/components/dist-versioned';
import { Filter } from 'src/openapi-client';


export enum Type {
  DROPDOWN = "DROPDOWN",
  RADIO_BUTTON = "RADIO_BUTTON",
  DATE_PICKER = "DATE_PICKER"

}
@Component({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  selector: 'wct-filter',
  imports: [],
  templateUrl: './filter.component.html',
  styleUrl: './filter.component.scss',
})
export class FilterComponent {

  readonly Type = Type;

  public readonly SIZE = 'lg';

  public readonly showLabel = input(false);

  public readonly type = input(Type.DROPDOWN);
  public readonly multiValue = input(true);
  public readonly range = input(false);
  public readonly filter = input.required<Filter>();

  readonly datePicker = viewChild<ElementRef<SdDatepicker>>('datePicker');

  readonly selectedValue = linkedSignal<string[]>(() => this.filter().preselection ? this.filter().preselection!.map(v => this.keyForSolid(v)) : [] as string[]);

  readonly selected = output<string[]>();

  readonly available = computed(() => {
    return this.filter().available.map(v => {
      return {key: this.keyForSolid(v), value: v};
    });
  });

  constructor() {
    effect(() => {
      const el = this.datePicker()?.nativeElement;
      if (el) {
        el.isDateDisabled = (date: Date) => {
          const local = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
          return false; // !this.filter().available.includes(local);
        };
      }
    });
  }

  private keyForSolid(value: string): string {
    return value.replace(/\s/g, 'xxxSPACExxx');
  }

  private keyFromSolid(value: string): string {
    return value.replace(/xxxSPACExxx/g, ' ');
  }

  changeSelection($event: Event) {
    if (this.type() === Type.RADIO_BUTTON) {
      const radioGroup = $event.target as SdRadioGroup & { value?: string };
      const value = radioGroup.value as string;
      this.selectedValue.set(value ? [value] : []);
      this.selected.emit(this.selectedValue().map(v => this.keyFromSolid(v)));
      return;
    }
    const rawValue = ($event.target as SdSelect).value as string | string[];
    const values = Array.isArray(rawValue) ? rawValue : rawValue ? [rawValue] : [];
    this.selectedValue.set(values);
    this.selected.emit(values.map(v => this.keyFromSolid(v)));
  }

  changeDate($event: Event) {
    const el = $event.target as SdDatepicker & { rangeStart?: string; rangeEnd?: string };

    if (this.range()) {
      const start = el.rangeStart ?? this.splitRange(el.value)[0];
      const end = el.rangeEnd ?? this.splitRange(el.value)[1];
      const values = [start, end].filter((v): v is string => !!v);
      this.selectedValue.set(values);
      this.selected.emit(values);
      return;
    }

    const value = el.value as string;
    this.selectedValue.set(value ? [value] : []);
    this.selected.emit(this.selectedValue());
  }

  private splitRange(value: string | null): [string?, string?] {
    if (!value) {
      return [undefined, undefined];
    }
    const parts = value.split(/\s*(?:-|–|bis|to)\s*|\s+/).filter(Boolean);
    return [parts[0], parts[1]];
  }
}
